import { render, staticRenderFns } from "./EditEmptyAppoint.vue?vue&type=template&id=704d63a9&scoped=true&"
import script from "./EditEmptyAppoint.vue?vue&type=script&lang=js&"
export * from "./EditEmptyAppoint.vue?vue&type=script&lang=js&"
import style0 from "./EditEmptyAppoint.vue?vue&type=style&index=0&id=704d63a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d63a9",
  null
  
)

export default component.exports